import { render } from "./LoadingWheel.3.vue?vue&type=template&id=3ca64adc&ts=true"
import script from "./LoadingWheel.3.vue?vue&type=script&lang=ts"
export * from "./LoadingWheel.3.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__